import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@chakra-ui/react';

const Board = ({ children, showSkeleton }) => {
  if (showSkeleton) {
    return (
      <Skeleton
        h={{
          base: '98px',
          sm: '109px',
        }}
      />
    );
  }

  return <div className="member-center__board">{children}</div>;
};

Board.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  showSkeleton: PropTypes.bool,
};

export default Board;
